import Riveted from "../analytics/Riveted.js";
document.addEventListener("DOMContentLoaded", function () {
  Riveted.init({
    reportInterval: 30
  });
});